export default "__VITE_ASSET__D_t5DZBc__"